export default __webpack_public_path__ + "9c6b505ef778055bec1a7aad55421b1c.svg";